module.exports = __webpack_public_path__ + "img/t1-4.5ca5549e.svg";